import WhySection from './WhySection'

export default WhySection
